// Partial Mappers

export function pricingScopeMapper(params) {
  let payload = {};
  if (params.config.featuresFlags.pricingScope !== 'none') {
    payload = {
      options: {
        pricingScope: params.config.featuresFlags.pricingScope
      }
    };
  }
  return payload;
}